export default "__VITE_ASSET__BmH79d_a__"